//@flow
import React from 'react';
import { Container } from 'flux/utils';
import CategoriesStore from '../../Stores/MemberCategories/categories';
import QuoteStore from '../../Stores/Quote';
import ProductsStore from '../../Stores/Products/products';
import CustomerStore from '../../Stores/Customer/customer';
import ItemQty from './ItemQty.react';

import type { List } from 'immutable';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type QuoteItemModel from '../../Stores/Quote/quoteItemModel';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type QuoteModel from '../../Stores/Quote/quoteModel';

type Props = {
  maxQty?:number,
  minQty?:number,
  className:string,
  displayComponentClass:?any,
  quoteId:?string,
  sku:?string,
  inStock?:?boolean,
  showOOSView?:'product'|'tooltip',
  stockReminders?:List<string>,
  inAlsoLike?:boolean,
  idx?:number,
  userCountry?:string,
  notAllowedReasons?:?string[],
  onAdd?:() => void,
  inCheckout?:boolean,
};

type State = {
  categories:CategoriesCollection,
  quoteItems:QuoteItemsCollection,
  quoteItem:?QuoteItemModel,
  products:ProductsCollection,
  customer:CustomerModel,
  quote:?QuoteModel,
};

class ItemQtyWrapper extends React.Component<Props, State> {
  static getStores() {
    return [
      QuoteStore,
      CategoriesStore,
      ProductsStore,
      CustomerStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    const quoteItems = QuoteStore.getQuoteItems(props.quoteId);
    const quote = props.quoteId ? QuoteStore.getQuoteById(props.quoteId) : null;

    return {
      quote,
      quoteItems,
      categories: CategoriesStore.getCategories(),
      quoteItem: quoteItems.getQuoteItemBySku(props.sku || ''),
      products: ProductsStore.getProducts(),
      customer: CustomerStore.getCustomer(),
    };
  }

  render() {
    return (
      <ItemQty
        {...this.state}
        {...this.props}
      />
    );
  }
}

export default Container.create(ItemQtyWrapper, { withProps: true });
